module.exports = __webpack_public_path__ + "4c747759d8a3b9a42e5e71982fe6068c.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/Popup.png
// module id = 2150
// module chunks = 0